import { LogManager } from "./logging/LogManager";
import { UserSettings } from "./settings/UserSettings";

const log = LogManager.getLogger("core.LogicResponsibilityFiltering");

export class LogicResponsibilityFiltering {
    public static userHasResponsibility(testCodes: string[]): boolean {
        const userRfCodes = UserSettings.get()?.responsibility_codes;
        if (userRfCodes == null) {
            return true;
        }
        if (testCodes != null && testCodes.length > 0) {
            for (const testCode of testCodes) {
                if (userRfCodes.includes(testCode)) {
                    return true;
                }
            }
        }
        return false;
    }
}
